import { type HTMLAttributes, type Ref } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

export const emptyStateMediaVariants = cva("flex shrink-0 items-center justify-center [&_svg]:pointer-events-none", {
  variants: {
    variant: {
      default: "bg-transparent",
      icon: "h-10 w-10 rounded-[calc(var(--radius)-2px)] bg-muted text-foreground [&_svg:not([class*='size-'])]:h-5 [&_svg:not([class*='size-'])]:w-5",
    },
  },
  defaultVariants: { variant: "default" },
});

export interface EmptyStateMediaProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof emptyStateMediaVariants> {
  ref?: Ref<HTMLDivElement>;
}

export const EmptyStateMedia = ({ className, variant, ref, ...props }: EmptyStateMediaProps) => (
  <div
    ref={ref}
    data-slot="empty-state-media"
    data-variant={variant ?? "default"}
    className={cn(emptyStateMediaVariants({ variant }), className)}
    {...props}
  />
);
